export var PermissionRuleName = /*#__PURE__*/ function(PermissionRuleName) {
    PermissionRuleName["DashboardPage"] = "page:dashboard";
    PermissionRuleName["ReportsPage"] = "page:reports";
    PermissionRuleName["ResourceManagementPage"] = "page:resource-management";
    PermissionRuleName["TimesheetPage"] = "page:timesheet";
    PermissionRuleName["TemplatePage"] = "page:template";
    PermissionRuleName["BillingPage"] = "page:settings:billing";
    PermissionRuleName["TeamMemberSettingPage"] = "page:settings:team-member";
    PermissionRuleName["OrganisationSettingsPage"] = "page:settings:organisation";
    PermissionRuleName["HolidayCalendarSettingsPage"] = "page:settings:holiday-calendar";
    PermissionRuleName["PartnerSettingPage"] = "page:settings:partner";
    PermissionRuleName["RoleSettingPage"] = "page:setting:role";
    PermissionRuleName["CustomDomainSettingPage"] = "page:setting:custom-domain";
    PermissionRuleName["EmailConfigurationSettingPage"] = "page:setting:email-configuration";
    PermissionRuleName["SecuritySettingPage"] = "page:setting:security";
    PermissionRuleName["IntegrationSettingPage"] = "page:setting:integration";
    PermissionRuleName["TimesheetSettingPage"] = "page:setting:timesheets";
    PermissionRuleName["ResourceManagementSettingPage"] = "page:setting:resource-management";
    PermissionRuleName["AdvancedSettingPage"] = "page:setting:advanced";
    PermissionRuleName["ProjectFieldSettingPage"] = "page:setting:project-field";
    PermissionRuleName["TaskFieldSettingPage"] = "page:setting:task-field";
    PermissionRuleName["TeamMemberFieldSettingPage"] = "page:setting:team-member-field";
    PermissionRuleName["CustomerPortalSettingPage"] = "page:setting:customer-portal-notification";
    PermissionRuleName["ProjectCreateAction"] = "action:project:create";
    PermissionRuleName["ProjectViewAsCustomerAction"] = "action:project:view-as-customer";
    PermissionRuleName["ProjectChangeTabVisibilityAction"] = "action:project:change-tab-visibility";
    PermissionRuleName["ProjectOverviewPage"] = "page:project:overview";
    PermissionRuleName["ProjectFinancialsPage"] = "page:project:financials";
    PermissionRuleName["ProjectPlanPage"] = "page:project:plan";
    PermissionRuleName["ProjectSpacesPage"] = "page:project:spaces";
    PermissionRuleName["ProjectFormResponsePage"] = "page:project:form-responses";
    PermissionRuleName["ProjectStatusUpdatePage"] = "page:project:status-update";
    PermissionRuleName["ProjectHoursSection"] = "section:project:project-hours";
    PermissionRuleName["ProjectGoalsSection"] = "section:project:business-goals";
    PermissionRuleName["ProjectPlannedVsActualSection"] = "section:project:planned-vs-actual";
    PermissionRuleName["ProjectFieldsInOverviewSection"] = "section:project:overview-fields";
    PermissionRuleName["ProjectNativeMoneyFieldSection"] = "section:project-field:money-field";
    PermissionRuleName["ProjectCustomFieldSection"] = "section:project-field:custom-field";
    PermissionRuleName["ProjectPhaseCreateAction"] = "action:project-phase:create";
    PermissionRuleName["ProjectPhaseEditAction"] = "action:project-phase:edit";
    PermissionRuleName["ProjectPhaseAddTasksAction"] = "action:project-phase:add-tasks";
    PermissionRuleName["ProjectExportPrivateResourceAction"] = "action:project:export-private-tasks";
    PermissionRuleName["ProjectPhaseRearrangeTasksAction"] = "action:project-phase:rearrange-tasks";
    PermissionRuleName["StatusUpdateCreatePrivateAction"] = "action:status-update:create-private";
    PermissionRuleName["StatusUpdateCreateAction"] = "action:status-update:create";
    PermissionRuleName["FileGroupCreateAction"] = "action:file:group-create";
    PermissionRuleName["FilePrivateGroupCreateAction"] = "action:file:private-group-create";
    PermissionRuleName["FileUploadAction"] = "action:file:update";
    PermissionRuleName["FormResponseEditAction"] = "action:form-response:edit";
    PermissionRuleName["FormResponseDeleteAction"] = "action:form-response:delete";
    PermissionRuleName["ProjectChatCreateAction"] = "action:project-chat:create";
    PermissionRuleName["ProjectChatPrivateCreateAction"] = "action:project-chat:private-create";
    PermissionRuleName["ProjectChatDeleteAction"] = "action:project-chat:delete";
    PermissionRuleName["ProjectChatEditAction"] = "action:project-chat:edit";
    PermissionRuleName["SpacePrivateSection"] = "section:space:private";
    PermissionRuleName["SpaceSharedCreateAction"] = "action:space:shared-create";
    PermissionRuleName["SpaceSharedEditAction"] = "action:space:shared-edit";
    PermissionRuleName["SpaceSharedDeleteAction"] = "action:space:shared-delete";
    PermissionRuleName["SpaceSharedDocumentCreateAction"] = "action:space:shared-document-create";
    PermissionRuleName["SpaceSharedDocumentDeleteAction"] = "action:space:shared-document-delete";
    PermissionRuleName["SpaceSharedDocumentRearrangeAction"] = "action:space:shared-document-rearrange";
    PermissionRuleName["SpaceDocumentInsertPrivateSectionAction"] = "action:space:insert-private-section";
    PermissionRuleName["SpaceDocumentFreezeAction"] = "action:space:document-freeze";
    PermissionRuleName["CommentPrivateMessageCreateAction"] = "action:comment:private-message-create";
    PermissionRuleName["ApprovalPrivateCreateAction"] = "action:approval:private-create";
    PermissionRuleName["TaskCreateAction"] = "action:task:create";
    PermissionRuleName["TaskDeleteAction"] = "action:task:delete";
    PermissionRuleName["TaskNameEditAction"] = "action:task-name:edit";
    PermissionRuleName["TaskChangePrivacyAction"] = "action:task:change-privacy";
    PermissionRuleName["TaskMoveBetweenPhaseAction"] = "action:task:move";
    PermissionRuleName["TaskDuplicateAction"] = "action:task:duplicate";
    PermissionRuleName["TaskPrivateDescriptionSection"] = "section:task:private-description";
    PermissionRuleName["TaskAddDependentTaskAction"] = "action:task:add-dependent-task";
    PermissionRuleName["TaskRemoveDependentTaskAction"] = "action:task:remove-dependent-task";
    PermissionRuleName["TaskCsatSection"] = "section:task:csat";
    PermissionRuleName["TaskCreateJiraIssueAction"] = "action:task:create-jira-issue";
    PermissionRuleName["ProjectSettingDetailPage"] = "page:project:detail-settings";
    PermissionRuleName["ProjectSettingVisibilityPage"] = "page:project:visibility-settings";
    return PermissionRuleName;
}({});
